import * as React from "react";
import { PermissionEnum } from "../../../misc/api/ApiPermissionEnum";
import { Authorization } from "../../../misc/components/Authorization";
import { Link } from "react-router-dom";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import { useSecurityContext } from "../../../Core/SecurityContext";

export const MenuItems = ({ }): JSX.Element => {

    const { study } = useCurrentStudyConfigurationContext();
    const { currentUserPermissions } = useSecurityContext();
    
    return (<div className="ibox-tools">
        <Authorization permissionId={PermissionEnum.CreateFixedComment}
            studyId={study.id}
            currentPermissions={currentUserPermissions}
        >
            <Link id="create-new-fc" to="/FixedComments/Create" className="btn btn-primary">Create</Link>
        </Authorization>
    </div>);
};
